import {
  Flex,
  IconButton,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  useDisclosure,
} from '@chakra-ui/react';
import { mdiDotsHorizontal } from '@mdi/js';
import { PortalIcon } from 'features/common/components/PortalIcon';
import { history } from 'features/common/history/history';
import { useGetApplicationNodes } from 'features/common/tenant/hooks/useGetApplicationNodes';
import { RegenerateContextIdModal } from 'features/context-ids/features/context-ids-home/components/ContextIdsTable/RegenerateContextIdModal';
import {
  getContextIdDetailsDeleteRoute,
  getContextIdsEditRoute,
} from 'features/context-ids/routes';
import { ContextNameSection } from '../ContextNameSection';

export const Header = ({
  contextId,
  type,
  onSyncWithMasterContext,
  isSyncWithMasterContextLoading = false,
}: {
  contextId: string;
  type?: string;
  onSyncWithMasterContext?: () => void;
  isSyncWithMasterContextLoading?: boolean;
}) => {
  const { isOpen, onOpen, onClose } = useDisclosure();

  const { applicationsNodes } = useGetApplicationNodes();
  const handleRegenerate = () => onOpen();

  return (
    <Flex data-testid='app-details-header' justifyContent='space-between'>
      <ContextNameSection name={contextId} />
      <RegenerateContextIdModal
        isOpen={isOpen}
        onClose={onClose}
        contextId={contextId}
        applicationsNodes={applicationsNodes}
      />
      <Flex gap={2}>
        <Menu placement='bottom-end'>
          <MenuButton
            onClick={(event) => event.stopPropagation()}
            as={IconButton}
            size='sm'
            variant='ghost'
            role='button'
            aria-label='Context ID actions'
            icon={<PortalIcon path={mdiDotsHorizontal} />}
          />
          <MenuList>
            <MenuItem
              onClick={() =>
                history.push({
                  pathname: getContextIdsEditRoute(contextId),
                  search: history.location.search,
                })
              }
              data-behavior-analytics-id='edit-context-id-action-context-id-details-page'
            >
              Edit
            </MenuItem>
            {type === 'custom' && onSyncWithMasterContext && (
              <MenuItem
                onClick={onSyncWithMasterContext}
                isDisabled={isSyncWithMasterContextLoading}
                data-testid='sync-with-master-context-menu-item'
                data-behavior-analytics-id='sync-with-master-context-action-context-id-details-page'
              >
                Sync with master Context ID
              </MenuItem>
            )}
            {type === 'custom' ? (
              <MenuItem
                onClick={() =>
                  history.push({
                    pathname: getContextIdDetailsDeleteRoute(contextId),
                    search: history.location.search,
                  })
                }
                data-behavior-analytics-id='delete-context-id-action-context-id-details-page'
              >
                Delete
              </MenuItem>
            ) : (
              <MenuItem
                onClick={handleRegenerate}
                data-behavior-analytics-id='regenerate-context-id-action-context-id-details-page'
              >
                Regenerate
              </MenuItem>
            )}
          </MenuList>
        </Menu>
      </Flex>
    </Flex>
  );
};
